const BASE_PATH = "auth";
const USER_BASE_PATH = `${BASE_PATH}/user`;

export const AUTH_COOKIE_KEY = "authorization";

export const AuthEndpoint = {
    USER: `${USER_BASE_PATH}/current`,
    EDIT_USER: `${USER_BASE_PATH}/{id}`,
    SIGN_IN: `${BASE_PATH}/oauth/token`,
    SIGN_OUT: `${USER_BASE_PATH}/logout`,
    SIGN_UP: USER_BASE_PATH,
    CONFIRM: `${USER_BASE_PATH}/confirm`,
    RESEND_CONFIRMATION: `${USER_BASE_PATH}/confirm/resend`,
    PASSWORD_RESET: `${USER_BASE_PATH}/password/reset`,
    PASSWORD_CHANGE: `${USER_BASE_PATH}/password/change`,
};

export const AuthRequestProperty = {
    USERNAME: "username",
    PASSWORD: "password",
    GRANT_TYPE: "grant_type",
    REFRESH_TOKEN: "refresh_token",
};

export const Role = {
    COMPANY_MASTER: "COMPANY_MASTER",
    COMPANY_DOCTOR: "COMPANY_DOCTOR",
};